import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import Styles from "./styles.module.scss";
import Headline4 from "../../components/headings/Headline4";
import { Icon } from "@iconify/react";
import ExperienceModal from "../../modal/createResource/experienceModal";
import ProjectForm from "../../dashboardFormComponents/projectForm";
import DeleteModal from "../../modal/createResource/deleteModal";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { getDetails, submitDetails } from "./services";
import NotificationAlert from "../../components/notification";
// import mixpanelData from '../../utils/mixpanel';
import classnames from "classnames";
import DOMPurify from "dompurify";
import {
  EditorState,
  convertToRaw,
  convertFromRaw,
  Modifier,
  ContentState,
} from "draft-js";
import draftToHtml from "draftjs-to-html";
import { convertToHTML } from "draft-convert";
import mixpanelData from "../../utils/mixpanel";
interface Props {
  ExperienceHandler: (event: any) => void;
  ProjectHandler: (event: any) => void;
  getUserDetails: (event: any) => void;
  // Back: (event: React.MouseEvent<HTMLButtonElement>) => void
  defaultValues: {
    workHistory: {
      designation: string;
      companyName: string;
      description: string;
      startDate: number;
      endDate: number;
      stillWorking: boolean;
    }[];
    project: {
      name: string;
      companyName: string;
      doneFor: string;
      contribution: string;
      skills: { skillName: string; skillId: number }[];
      link: string;
    }[];
  };
  loginId: string | null;
  userLoginId: string | null;
  displayNotification: (event: string) => void;
  skillsList: any;
}

const Projects: React.FC<Props> = ({
  ExperienceHandler,
  ProjectHandler,
  getUserDetails,
  displayNotification,
  loginId,
  defaultValues,
  userLoginId,
  skillsList
}) => {
  const { v4: uuidv4 } = require("uuid");
  const [initialProjectValues, setInitialProjectValues] = useState<any>();
  const [section, setSection] = useState<string>("");
  const [notification, setNotification] = useState<boolean>(false);
  const [message, setMessage] = useState<string>("");
  const [projectIndex, setProjectIndex] = useState<any>(-1);
  const [visibleDeleteModal, setVisibleDeleteModal] = React.useState(true);
  const [newProject, setNewProject] = useState<boolean>(false);
  const [editProject, setEditProject] = useState<boolean>(false);
  const [editorState, setEditorState] = useState<any>(
    EditorState.createEmpty()
  );

  useEffect(() => {
    if (defaultValues) {
      setInitialProjectValues(defaultValues.project);
    }
  }, [defaultValues]);

  const projectVisiblity = () => {
    setProjectIndex(-1);
    setNewProject(true);
  };

  const deleteVisiblity = () => {
    setVisibleDeleteModal(!visibleDeleteModal);
  };

  const addProjects = (data: any) => {
    let finalValue = {
      project: {
        projectId: data.projectId ? data.projectId : uuidv4(),
        name: data.name,
        link: data.link,
        status: true,
        companyName: data.companyName,
        skills: data.skills,
        contribution: data.contribution,
        doneFor: data.doneFor,
      },
      action: data.action,
      section: "project",
      loginId: loginId,
      userLoginId: userLoginId,
      submittedBy: "RECRUITER",
    };

    submitDetails(finalValue).then((response: any) => {
      if (response && response.status === 1 ) {
        mixpanelData('TG - Projects updated', {
                    'source': "Recruiter updates personal details",
                    'Success':  true,
                    'distinct_id': localStorage.getItem('Email'),
                    'Recruiter email': localStorage.getItem('Email'), 
                    'Phone Number': response && response.data[0].profile_metadata.phoneNumber ,
                    'Name': response && (response.data[0].profile_metadata.firstName + ' ' + response.data[0].profile_metadata.lastName),
                    'Email': response.data[0].profile_metadata.email,
                    'Project Name': data.name,
                    'link': data.link,
                    'companyName': data.companyName,
                    'skills': data.skills && data.skills.length > 0 && data.skills.map((item: any) => item.skillName),
                    'doneFor': data.doneFor
                  })
                  mixpanelData('New TG - Projects updated', {
                    'source': "Recruiter updates projects",
                    'Success':  true,
                    'distinct_id': localStorage.getItem('Email'),
                    'Recruiter email': localStorage.getItem('Email'), 
                    'Phone number': response && response.data[0].profile_metadata.phoneNumber ,
                    'Candidate name': response && (response.data[0].profile_metadata.firstName + ' ' + response.data[0].profile_metadata.lastName),
                    'Candidate email': response.data[0].profile_metadata.email,
                    'Project name': data.name,
                    'Link': data.link,
                    'Company name': data.companyName,
                    'Skills': data.skills && data.skills.length > 0 && data.skills.map((item: any) => item.skillName),
                    'Done for': data.doneFor,
                    'Candidate loginid': loginId,
                  })

        getDetails(loginId).then((resp: any) => {
          setInitialProjectValues(resp.data[0].profile_metadata.project);
          getUserDetails(loginId);
          getUserDetails(loginId);
          displayNotification("Details saved successfully");
          //   setMessage('Details saved successfully')
          //   setNotification(true)
          //   setTimeout(() => {
          //   setNotification(false)
          // }, 3000);
        });
        onClose();
      }
    });
  };
  const createMarkup = (html: any) => {
    if (html.includes('{"blocks')) {
      let oldblockconverteddata = convertFromRaw(JSON.parse(html));
      let oldblockdataconvertedhtml = convertToHTML(oldblockconverteddata);

      html = JSON.stringify(oldblockdataconvertedhtml);
      return {
        __html: DOMPurify.sanitize(html),
      };
    }
    if (html.includes("<p>") || html.includes("<ol") || html.includes("<ul>")) {
      return {
        __html: DOMPurify.sanitize(JSON.parse(html)),
      };
    } else {
      html = "<p>" + html + "</p>";
      return {
        __html: DOMPurify.sanitize(html),
      };
    }
  };
  const Delete = (section: string) => {
    let value = {
        action: "delete",
        section: "project",
        loginId: loginId,
        userLoginId: userLoginId,
        submittedBy: "RECRUITER",
        project: {
          projectId: initialProjectValues[projectIndex].projectId,
        },
      };

    submitDetails(value).then((response: any) => {
      if (response && response.status === 1 ) {
        deleteVisible();
        mixpanelData('New TG - Projects updated deleted', {
          'source': "Recruiter updates projects",
          'Success':  true,
          'distinct_id': localStorage.getItem('Email'),
          'Recruiter email': localStorage.getItem('Email'), 
          'Phone  number': response && response.data[0].profile_metadata.phoneNumber ,
          'Candidate name': response && (response.data[0].profile_metadata.firstName + ' ' + response.data[0].profile_metadata.lastName),
          'Candidate email': response.data[0].profile_metadata.email,
          'Project name': initialProjectValues[projectIndex].name,
          'Project id': initialProjectValues[projectIndex].projectId,
          'Candidate loginid': loginId,
        })
        delete initialProjectValues[projectIndex];
        getDetails(loginId).then((resp: any) => {
          setInitialProjectValues(resp.data[0].profile_metadata.project);
          displayNotification("Details deleted successfully");
          //   setMessage('Details deleted successfully')
          //   setNotification(true)
          //   setTimeout(() => {
          //   setNotification(false)
          // }, 3000);
        });
      }
    });
  };

  const deleteVisible = () => {
    setVisibleDeleteModal(!visibleDeleteModal);
    setProjectIndex(-1);
  };

  const onClose = () => {
    setNotification(false);
    setProjectIndex(-1);
    setNotification(false);
    setNewProject(false);
    setEditProject(false);
  };
  const convert = (item: any) => {
    if (item) {
      const contentState = editorState.getCurrentContent();
      if (JSON.stringify(convertToRaw(contentState)) !== item) {
        try {
          // setEditorState(EditorState.createWithContent(convertFromRaw(JSON.parse(item))));
          let abd = draftToHtml(
            convertToRaw(
              EditorState.createWithContent(
                convertFromRaw(JSON.parse(item))
              ).getCurrentContent()
            )
          );
          let strippedHtml = abd.replace(/<[^>]+>/g, "");
          return strippedHtml;
        } catch (e) {
          // setEditorState(EditorState.createWithContent(ContentState.createFromText(item)));
          return item;
        }
      }
    }
  };

  return (
    <section>
      {notification && (
        <NotificationAlert onClose={onClose} closable={true}>
          {message}
        </NotificationAlert>
      )}

      {/* {!eduvisible && ( <EducationModal ClickHandler={submitEducation} defaultValues={educationIndex !== -1 ? education[educationIndex] : ''} onClose={addEducationModal} /> )} */}
      {!visibleDeleteModal && (
        <DeleteModal
          onClose={deleteVisible}
          onSubmit={Delete}
          section={section}
        />
      )}

      {/* <Headline4>Academic Details</Headline4> */}
      {initialProjectValues &&
        initialProjectValues.map((item: any, key: any) => {
          return (
            <div className="mb-10">
              {key !== projectIndex ? (
                <div className={Styles.workExpWrapper} key={key}>
                  <div className={Styles.workExpCard}>
                    <div className={Styles.workExpHead}>
                      <div>
                        <h6>
                          {item.name && item.name} {item.name && "|"}{" "}
                          {item.companyName && item.companyName}
                        </h6>
                      </div>
                      <div className={Styles.actions}>
                        <Icon
                          icon="lucide:edit-2"
                          onClick={() => {
                            setEditProject(true);
                            setProjectIndex(key);
                          }}
                        />
                        <Icon
                          icon="mdi:trash-can-outline"
                          onClick={() => {
                            deleteVisiblity();
                            setProjectIndex(key);
                            setSection("project");
                          }}
                        />
                      </div>
                    </div>
                    <div className={Styles.projectSkills}>
                      {item.skills &&
                        item.skills.length !== 0 &&
                        item.skills.map((item: any, key: number) => {
                          return (
                            <div className={Styles.item}>{item.skillName}</div>
                          );
                        })}{" "}
                    </div>
                    {/* <div>
                      {item.contribution &&
                        convert(item.contribution)
                          .split("\n")
                          .map((item: any, i: any) => (
                            <p key={i}>{item}</p>
                          ))}{" "}
                    </div> */}

                    <div
                      className="preview"
                      dangerouslySetInnerHTML={
                        item.contribution && createMarkup(item.contribution)
                      }
                    ></div>
                  </div>
                </div>
              ) : (
                <ProjectForm
                    ClickHandler={addProjects}
                    skillsList={skillsList}
                  defaultValues={
                    projectIndex !== -1
                      ? initialProjectValues[projectIndex]
                      : ""
                  }
                  onClose={onClose}
                />
              )}
            </div>
          );
        })}
      <div>
        {newProject ? (
          <ProjectForm
            ClickHandler={addProjects}
            skillsList={skillsList}
            defaultValues={
              projectIndex !== -1 ? initialProjectValues[projectIndex] : ""
            }
            onClose={onClose}
          />
        ) : (
          <button className={Styles.addWorkHistory} onClick={projectVisiblity}>
            <Icon icon="fluent:add-circle-28-regular" />
            Projects
          </button>
        )}
      </div>
    </section>
  );
};
export default Projects;
